import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        classDate: {
            date : ""
        },
        roleId : 0,
        roleName : "",
    },
    getters: {},
    mutations: {
        setDate (state, payload) {
            state.classDate.date = payload
        },
        setRoleId(state, payload) {
            state.roleId = payload
        },
        setRoleName(state, payload) {
            state.roleName = payload
        }
    },
    actions: {}
});


// WEBPACK FOOTER //
// ./src/store/index.js